import { render, staticRenderFns } from "./AppointmentsAdminSelector.vue?vue&type=template&id=9f4d0e50&scoped=true"
import script from "./AppointmentsAdminSelector.vue?vue&type=script&lang=ts"
export * from "./AppointmentsAdminSelector.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentsAdminSelector.vue?vue&type=style&index=0&id=9f4d0e50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4d0e50",
  null
  
)

export default component.exports